import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: 'modal-login-form-member',

  ui: {
    subscribeButton: '[js-subscribe-button]',
  },

  events: [
    {
      target: 'subscribeButton',
      on: 'click',
      handle () {
        this.el.querySelector('.modal__close-button').click()
      },
    },
  ],

  componentDidMount () {
    setTimeout(() => {
      this.innerSwiper = new Swiper(
        this.el.querySelector('.swiper-member-login'),
        {
          // Optional parameters
          direction: 'horizontal',
          speed: 600,
          // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
          // reverseDirection: true,
          loop: true,
          // loopedSlides: 5,
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-member-login-button-next',
            prevEl: '.swiper-member-login-button-prev',
          },
          slidesPerView: 1,
          spaceBetween: 16,
          // slidesOffsetBefore: 0,

          /*  autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        }, */

          /* on: {
          slideChangeTransitionEnd: function () {
            that.updateCounter(this.realIndex)
            that.animate(true)
          },

          slideChangeTransitionStart: function () {
            that.animate(false)
          }
        },, */
          // breakpointsInverse: true,
        }
      )
    }, 200)
  },
}
